import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted,onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { Toast } from "vant";
import { encryptionEditName } from "@/api/php/user";
import { mgs_set_sign } from "@/network/socket/SocketReq";
import EventBus from "@/uitls/EventBus";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  name: 'Sign',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "3fe8e8ca-btnTextColor": (btnTextColor.value),
  "3fe8e8ca-btnColor": (btnColor.value)
}))

const { t } = useI18n();
const piniaStore = usePiniaState();
const { user, isYk } = storeToRefs(piniaStore);
const { toLogin, Revisename } = piniaStore;
const router = useRouter();
let sign = ref("");
// const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;
const primaryColor = '#0D0D0D';
const btnColor = ref("#ECECEC")
const btnTextColor = ref("#898989")
// changeSignSuccecc

onMounted(() => {
    toLogin();
    sign.value = user.value.sign;
});

onUnmounted(()=>{
    EventBus.off("changeSignSuccecc")
})

EventBus.on("changeSignSuccecc", () => {
    Toast.success(t('me.szcg'))
    user.value.sign = sign.value
    router.back()
})
const ok = async () => {
    if (sign.value == user.value.sign) {
        Toast({
            message: t('me.qsxt'),
            position: "bottom",
        });
    } else if (sign.value == "") {
        Toast({
            message: t('me.qsxt'),
            position: "bottom",
        });
    } else {
        // const res: any = await encryptionEditName({ username: sign.value });
        // if (res.code == 200) {
        //     Revisename(sign.value);
        //     Toast.success("修改签名成功");
        //     router.back();
        // }
        // console.log(res);
        mgs_set_sign(sign.value)
    }
};
const changeText = (e: string) => {
    if (e.length > 3) {
        btnColor.value = primaryColor
        btnTextColor.value = "#fff"
    } else {
        btnColor.value = "#ECECEC"
        btnTextColor.value = "#898989"
    }
}

const __returned__ = { t, piniaStore, user, isYk, toLogin, Revisename, router, sign, primaryColor, btnColor, btnTextColor, ok, changeText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})